import { ReactNode } from 'react';

interface SelectionButtonProps {
  isSelected: boolean;
  onClick: () => void;
  className?: string;
  children: ReactNode;
}

export function SelectionButton({
  isSelected,
  onClick,
  className = '',
  children,
}: SelectionButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`py-8 px-6 transition-all duration-300 rounded-2xl   border-2 ${
        isSelected
          ? 'shadow-[var(--shadow-md)] border-[var(--clinic-secondary)]'
          : ' hover:shadow-md border-gray-200'
      } ${className}`}
    >
      {children}
    </button>
  );
}
